module.exports = __webpack_public_path__ + "static/media/view staff.05e62b2d.svg";